import { useState } from "react";
import Button from "../Button/Button";

import styles from "./ConfirmUser.module.css";

export default function ConfirmUserButton({
  userId,
  confirm,
  type,
}: {
  userId: string;
  confirm: boolean;
  type: "primary" | "secondary";
}) {
  const [status, setStatus] = useState("");

  const confirmUser = async () => {
    setStatus("A guardar...");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/users`,
        {
          method: "PATCH",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ confirm, userId }),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setStatus(
          confirm ? "Confirmado com sucesso!" : "Cancelado com sucesso"
        );
      } else {
        setStatus(`Error: ${result.error}`);
      }
    } catch {
      setStatus("Falha em atualizar presença.");
    }
  };

  return (
    <div className={styles.container}>
      <Button
        type={type}
        handleClick={confirmUser}
        label={
          status === "A guardar..."
            ? "A guardar..."
            : confirm
            ? "Confirmar"
            : "Cancelar"
        }
      />
      <p>{status}</p>
    </div>
  );
}
